// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyB3PNPty6lQycVPPy-6Q3B8nS89UyYYIRw",
//   authDomain: "edvize-140a2.firebaseapp.com",
//   projectId: "edvize-140a2",
//   storageBucket: "edvize-140a2.appspot.com",
//   messagingSenderId: "640381962200",
//   appId: "1:640381962200:web:6a1e3f830d30286d97d4ad",
//   measurementId: "G-CK90NCFMDC"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
import { getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBU5sCLgzQFWs3DYMyuk1LYZmyX4HxV13c",
  authDomain: "edvize-server.firebaseapp.com",
  projectId: "edvize-server",
  storageBucket: "edvize-server.appspot.com",
  messagingSenderId: "833525732562",
  appId: "1:833525732562:web:71e279045af9228994490b",
  measurementId: "G-E9GEEGLV9J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics);


// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
console.log(firebaseApp);

// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({   
    prompt : "select_account "
});
export const auth = getAuth(app);
// export const signInWithGooglePopup = () => signInWithPopup(auth, provider);

export const firestore = getFirestore(app);
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);
export const signOutUser = () => signOut(auth);